import React from 'react';
import PropTypes from 'prop-types';
import Header from 'cccisd-header';
import style from './style.css';

const Fortress = window.cccisd?.fortress;

const resourceLinks = [
    { url: 'https://producer.3cisd.com/resource/viewshare/1/e9d4d3', label: 'Producer User Guide' },
    {
        url: 'https://producer.3cisd.com/resource/viewshare/2/ddd057',
        label: 'CyberDuck Setup Guide',
    },
].map(link => ({ ...link, action: () => window.open(link.url, '_blank', 'noopener') }));

const NavBar = ({ className }) => {
    return (
        <div className={`${style.navbar}`}>
            <Header
                primaryNavLinks={
                    Fortress.auth() ? [{ url: '/manage#siteAdmin', label: 'Manage Videos' }, ...resourceLinks] : []
                }
                containerClassName={className}
                wrapperClassName={style.wrapper}
                logoClassName={style.logo}
                logoLink={Fortress.auth() ? '/manage#siteAdmin' : '/'}
            />
        </div>
    );
};

NavBar.defaultProps = {
    className: 'container-fluid',
};

NavBar.propTypes = {
    className: PropTypes.string,
};

export default NavBar;
